import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, FormsModule, MaxLengthValidator, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SelectInputComponent, TextInputComponent, SelectOption, PhoneMaskDirective, NumberInputComponent, maxLengthNumberValidator,numberLengthValidator, ButtonComponent  } from 'ddmo-storybook-lib';
import { LABELS } from '../../../shared/constants/lables.constants';
import { SharedService } from '../../../shared/services/shared.service';
import { catchError,Subscription,throwError } from 'rxjs';
import {v4 as uuid4} from 'uuid';
import { environment } from '../../../../environments/environment';
import { LoaderService } from '../../../shared/services/loader.service';
import { FooterComponentLayout } from '../../../shared/components/footer/footer.component';

@Component({
    selector: 'app-signup',
    imports: [CommonModule, FormsModule, PhoneMaskDirective, ReactiveFormsModule, ButtonComponent, SelectInputComponent, NumberInputComponent, SelectInputComponent, TextInputComponent, FooterComponentLayout],
    templateUrl: './signup.component.html',
    styleUrl: './signup.component.scss'
})
export class SignupComponent implements OnInit, OnDestroy {
    currentSlide = 0;
    slideInterval: any;
    mainError = "" 
    errormessages = LABELS.ERROR_MESSAGES
    formData = {
        username: '',
        password: '',
        confirmPassword: '',
        dentistFirstName: '',
        dentistLastName: '',
        licenseNumber: '',
        licenseState: '',
        npiNumber: '',
        emailAddress: '',
        challengeQuestion: '',
        challengeAnswer: ''
    };
    PHONE_PATTERN = LABELS.PHONE_PATTERN ;
    EMAIL_PATTERN = LABELS.EMAIL_PTTERN;
  private npiNumberSubscription?: Subscription;
  private licenseNumberSubscription?: Subscription;
  private confirmPasswordSubscription?: Subscription;
  passwordMismatchError : boolean= false;
    public signupForm = new FormGroup(({
        email : new FormControl('',[Validators.required, Validators.pattern(this.EMAIL_PATTERN)]),
        password : new FormControl('', [Validators.required]),
        confirmPassword : new FormControl('',[Validators.required]),
        dentistFirstName : new FormControl('',[Validators.required,Validators.maxLength(50),Validators.pattern(LABELS.NUMBER_PATTERN),this.sharedService.noWhitespaceValidator()]),
        dentistLastName : new FormControl('',[Validators.required,Validators.maxLength(50),Validators.pattern(LABELS.NUMBER_PATTERN),this.sharedService.noWhitespaceValidator()]),
        licenseNumber : new FormControl('',Validators.required),
        licenseState : new FormControl('',Validators.required),
        npiNumber : new FormControl('',[Validators.required,]),
        phoneNumber : new FormControl('',[Validators.required,Validators.pattern(this.PHONE_PATTERN)]),
        
    }))
    licenseStateOptions: SelectOption[] = [
        { value: 'MO', viewValue: 'MO' },
        { value: 'SC', viewValue: 'SC' }
    ]

    challengeQuestions = [
        'What was the name of your first pet?',
        'What is your mother\'s maiden name?',
        'What city were you born in?',
        'What is your favorite color?',
        'What was the make of your first car?'
    ];
    registrationSuccess:boolean=false;
    registeredEmail:any='donotreply@deltadentalmo.com';
    constructor(private router: Router,private sharedService:SharedService,private loader:LoaderService) { }

    ngOnInit() {
        // Start slideshow
        this.slideInterval = setInterval(() => {
            this.currentSlide = (this.currentSlide + 1) % 2;
        }, 5000);
        this.setValidators()
    }

    ngOnDestroy() {
        if (this.slideInterval) {
            clearInterval(this.slideInterval);
        }
    }
  errormsg(fieldName: any) {
    if(fieldName == "Password"){
      return {
      ...this.errormessages,
      minlength: `${fieldName} must be at least 12 characters long`,
      customFieldValidation : "Password is too Weak"
    };
    }else if(fieldName == "npiNumber"){
      return {
        ...this.errormessages,
        customFieldValidation : "NPI is invalid"
      }
    }else if(fieldName == "licenseNumber"){
      return {
        ...this.errormessages,
        customFieldValidation : "License is invalid"
      }
    }
    return {
      ...this.errormessages,
      minlength: `${fieldName} doesn't meet requirements`
    };
  }

    onSignIn() {
        window.location.href = environment.redirectUrlAfterRegister
    }
     confirmPasswordValidator(passwordValue: string, confirmValue: string): ValidationErrors | null {
    if (passwordValue && confirmValue && passwordValue !== confirmValue) {
      return { mismatch: true };
    }
    return null;
  }
    restrictNonNumeric(event: KeyboardEvent): void {
   this.sharedService.preventNonNumeric(event);
  }
  private validateMaxLength() {
    let npiNumber:any = this.signupForm.get('npiNumber')
    numberLengthValidator(npiNumber,10,10,'custom');

  }
  private Validatepassword(){

    // Run validator when confirmPassword changes
    this.signupForm.controls['confirmPassword'].valueChanges.subscribe((cnfValue:any) => {
      const passwordValue:any = this.signupForm.controls['password'].value;
      if(passwordValue && cnfValue){
      const error = this.confirmPasswordValidator(passwordValue, cnfValue);
      this.signupForm.controls['confirmPassword'].setErrors(error);
      }
    });
 
    // Also run validator when password changes
    this.signupForm.controls['password'].valueChanges.subscribe((passwordValue:any) => {
      const cnfValue:any = this.signupForm.controls['confirmPassword'].value;
      if(passwordValue && cnfValue){
      const error = this.confirmPasswordValidator(passwordValue, cnfValue);
      this.signupForm.controls['confirmPassword'].setErrors(error);
      }
    });
      
  }

  setValidators(){
    if (this.npiNumberSubscription) {
      this.npiNumberSubscription.unsubscribe();
      this.npiNumberSubscription = undefined;
    }
     const checkControl = this.signupForm.get('npiNumber');
      if (checkControl) {
        this.npiNumberSubscription = checkControl.valueChanges.subscribe(() => {
        this.validateMaxLength();
      });
  }
  if(this.licenseNumberSubscription){
    this.licenseNumberSubscription?.unsubscribe();
    this.licenseNumberSubscription = undefined
  }
  const licenseControl = this.signupForm.get('licenseNumber');
  if(licenseControl){
    this.licenseNumberSubscription = licenseControl.valueChanges.subscribe(()=>{
        this.validateLicenseNumber()
    })
  }
 
  this.validateLicenseNumber()
  this.Validatepassword()
}
private validateLicenseNumber() {
  const licenseControl:any = this.signupForm.get('licenseNumber');
  const providerType = this.signupForm.get('licenseState')?.value;
 
  if (providerType === 'MO') {
    numberLengthValidator(licenseControl, 5, 10,providerType);
  } else if (providerType === 'SC') {
    numberLengthValidator(licenseControl, 4, 5,providerType);
  }
}
onLicenseStateChange(event:any){
    this.validateLicenseNumber()
}

  onCreateAccount() {
    this.loader.show()  
    this.mainError = '';
    if (this.signupForm.invalid) {
      this.loader.hide()
      return;
    }
    const formValue = this.signupForm.value;
    const npi = formValue.npiNumber;
    const uuid = uuid4();
    localStorage.setItem('trailWebSessionId', uuid);
    const payload: any = {
      userName: formValue.email,
      firstName: formValue.dentistFirstName?.trim(),
      lastName: formValue.dentistLastName?.trim(),
      roleId: formValue.licenseState === 'MO' ? [3] : [4],
      emailAddress: formValue.email,
      password : formValue.password,
      licenseState: formValue.licenseState,
      licenseNumber: formValue.licenseNumber + '',
      phoneNumber: formValue.phoneNumber,
      npi: '' + npi,
      createdUserId: null,
      modifiedUserId: null,
      trailWebSessionId: uuid,
      userStatusId: 1,
      impersonatedByUserId: localStorage.getItem("impersonatedUserId") ? Number(localStorage.getItem("impersonatedUserId")) : null 
    };
    this.sharedService.createUser(payload).pipe(
      catchError((err: any) => {
        const message = err?.error?.message;
        this.sharedService.logError("APIFailed", "FileSignupComponent - createUser, Method:onCreateAccount", this.router.url.split('?')[0], err).subscribe();

        if (message === 'Invalid NPI') {
          // NPI validation failed
          this.signupForm.controls['npiNumber']
            .setErrors({ customFieldValidation: true });
        }
        else if (message === 'User already exists in db') {
          this.mainError = 'User is already registered';
        }else if(message === "User exists with different email"){
          this.mainError = 'User is already registered'
        }else if(message == 'Auth0 user creation failed'){
          this.mainError = 'Facing issue while create the user.try later'
        }else if(message == 'License is incorrect'){
          this.signupForm.controls['licenseNumber']
          .setErrors({ customFieldValidation: true });
        }else if(message == 'Password is too weak'){
          this.signupForm.controls['password']
          .setErrors({ customFieldValidation: true });
        }
        else{
          this.mainError = message
        }
        this.loader.hide()
        return throwError(() => err);
      })
    ).subscribe({
      next: (res) => {
        this.loader.hide();
        this.registrationSuccess = true; 
        
        window.scrollTo(0, 0);
      },
      error: (err) => {}
    });
  }
  logInWithAuth0(){
    const domain = environment.authTokenApi;
    const clientId = environment.auth0Config.clientIdExternal;
  
    const redirectUri = environment.redirect_uri_external
  
    // Generate nonce (sufficient for SPA)
    const nonce = Math.random().toString(36).substring(2);
  
    const authorizeUrl =
      `${domain}/authorize` +
      `?client_id=${clientId}` +
      `&response_type=code` +
      `&scope=openid profile email offline_access` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}` +
      `&nonce=${nonce}`;
  
    window.location.href = authorizeUrl;
  }
  get passwordValue(): string {
    return this.signupForm.get('password')?.value || '';
  }
  hasMinLength(): boolean {
    return this.passwordValue.length >= 12;
  }
  hasLowerCase(): boolean {
    return /[a-z]/.test(this.passwordValue);
  }
  hasUpperCase(): boolean {
    return /[A-Z]/.test(this.passwordValue);
  }
  hasNumber(): boolean {
    return /[0-9]/.test(this.passwordValue);
  }
  hasSpecialChar(): boolean {
    return /[!@#$%^&*]/.test(this.passwordValue);
  }
  hasNoTripleRepeat(): boolean {
    return !/(.)\1\1/.test(this.passwordValue);
  }
  hasAtLeastThreeConditions(): boolean {
    const conditions = [
      this.hasLowerCase(),
      this.hasUpperCase(),
      this.hasNumber(),
      this.hasSpecialChar()
    ];
    return conditions.filter(c => c).length >= 3;
  }
}
